import { render, staticRenderFns } from "./DiagItemMasterEdit.vue?vue&type=template&id=0d2a8b05&scoped=true&"
import script from "./DiagItemMasterEdit.vue?vue&type=script&lang=js&"
export * from "./DiagItemMasterEdit.vue?vue&type=script&lang=js&"
import style0 from "./DiagItemMasterEdit.vue?vue&type=style&index=0&id=0d2a8b05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a8b05",
  null
  
)

export default component.exports